import React from 'react';
import { getFieldValue } from '../../../contentful/mappers';
import './TextBlock.css';

function TextBlock({ data }) {
  if (!data) return null;

  const header1 = getFieldValue(data, 'header1');
  const header2 = getFieldValue(data, 'header2');
  const subtitle = getFieldValue(data, 'subtitle');
  const caption = getFieldValue(data, 'caption');
  const align = getFieldValue(data, 'align') || 'left';

  const hasAny =
    (header1 && header1.trim()) ||
    (header2 && header2.trim()) ||
    (subtitle && subtitle.trim()) ||
    (caption && caption.trim());

  if (!hasAny) return null;

  const alignClass =
    align === 'center' ? 'text-block-center' :
    align === 'right' ? 'text-block-right' :
    'text-block-left';

  return (
    <section className="text-block-section">
      <div className="container">
        <div className={`text-block ${alignClass}`}>
          {header1 && header1.trim() && (
            <h1 className="text-block-h1">{header1}</h1>
          )}
          {header2 && header2.trim() && (
            <h2 className="text-block-h2">{header2}</h2>
          )}
          {subtitle && subtitle.trim() && (
            <p className="text-block-subtitle">{subtitle}</p>
          )}
          {caption && caption.trim() && (
            <p className="text-block-caption">{caption}</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default TextBlock;

